<template>
  <v-app>
    <v-main class="fill-height" fluid>
      <v-main :class="authShellClass" />
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
const AUTH_ROUTES = [
  'login',
  'cadastrar',
  'recuperaracesso',
  'informarsenha',
  'selecionarEmpresa',
];

export default {
  name: 'App',

  computed: {
    /** Fundo laranja do app interno não deve vazar nas telas de auth (contraste ruim no login). */
    authShellClass() {
      return AUTH_ROUTES.includes(this.$route.name) ? 'back-auth' : 'back';
    },
  },
};
</script>
<style>
html,
body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.v-application {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
  color: #000 !important;
  background-color: #fff;
}

.back {
  background-color: #f27c00;
  font-family: 'Inter', sans-serif;
  height: 100%;
  position: absolute !important;
  top: 0px;
  left: 0px;
  width: 100% !important;
  z-index: -1;
}

/* Telas de login/cadastro/recuperação: sem laranja full-bleed (layout próprio cobre a viewport). */
.back-auth {
  background-color: #eef2f6;
  font-family: 'Inter', sans-serif;
  height: 100%;
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100% !important;
  z-index: -1;
}

.v-text-field,
.v-select,
.v-input,
.v-autocomplete {
  font-family: 'Inter', sans-serif;
}

/* Inter nos textos dos inputs e labels (padrão do projeto) */
.v-input input,
.v-input .v-label,
.v-select .v-select__selection,
.v-text-field input,
.v-autocomplete input {
  font-family: 'Inter', sans-serif !important;
}

/* Formulário básico: cantos retos / leve arredondamento */
.v-btn {
  border-radius: 4px;
  font-family: 'Inter', sans-serif;
}

/* Padrão do projeto: campos filled e outlined – fundo cinza claro, borda, sem sombra */
.v-text-field.v-input--is-filled .v-input__slot,
.v-text-field.v-input--is-outlined .v-input__slot,
.v-select.v-input--is-filled .v-input__slot,
.v-select.v-input--is-outlined .v-input__slot,
.v-autocomplete.v-input--is-filled .v-input__slot,
.v-autocomplete.v-input--is-outlined .v-input__slot {
  border-radius: 4px;
  background-color: #f0f0f0 !important;
  border: 1px solid #e0e0e0 !important;
  box-shadow: none !important;
}

.v-text-field .v-input__control .v-input__slot,
.v-select .v-input__control .v-input__slot,
.v-autocomplete .v-input__control .v-input__slot {
  box-shadow: none !important;
}

/* Remove qualquer sombra interna em focus/hover */
.v-text-field .v-input__slot fieldset,
.v-select .v-input__slot fieldset,
.v-autocomplete .v-input__slot fieldset {
  box-shadow: none !important;
}

/* Evita quebrar layout e alinhamento de inputs em telas complexas.
   Ajustes de espaçamento/altura devem ser locais por tela/componente. */
.v-container {
  font-family: 'Inter', sans-serif;
}

/* SweetAlert2 global: botão OK azul + centralização vertical */
.swal2-container {
  align-items: center !important;
}

.swal2-popup {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
  border-radius: 14px !important;
}

.swal2-actions {
  align-items: center !important;
}

.swal2-actions .swal2-styled {
  min-height: 40px;
  padding: 0 26px !important;
  text-align: center;
  line-height: 40px !important;
  border-radius: 999px !important;
  font-weight: 700 !important;
}

.swal2-actions .swal2-confirm {
  background-color: #0052A0 !important;
  color: #ffffff !important;
}

/* Spinner do :loading em botão preenchido sempre branco. Ele herda currentColor, que
   vira preto por causa do `.v-application { color: #000 !important }` acima. Botões
   text/outlined mantêm a cor própria (branco sumiria no fundo claro). */
.v-btn:not(.v-btn--text):not(.v-btn--outlined):not(.v-btn--plain):not(.v-btn--icon) > .v-btn__loader {
  color: #ffffff !important;
}
</style>
